<template>
  <div
    class="core por ova"
    :class="{
      en: $i18n.locale === 'en-US',
    }"
  >
    <div class="content">
      <div
        class="title-wrapper text-center wow animate__animated animate__fadeInUp"
      >
        <p class="section-title text-bold">{{ $t("home.core.title") }}</p>
        <p class="section-subtitle">{{ $t("home.core.subtitle") }}</p>
      </div>
      <div class="content-main flex wow animate__animated animate__fadeInUp">
        <!-- 左侧介绍 -->
        <div class="core-info flex column justify-between">
          <div class="info-panel ova">
            <p class="title section-title">{{ $t("home.core.core") }}</p>
            <p
              class="detail section-subtitle"
              v-html="$t('home.core.coreDetail')"
            ></p>
          </div>
          <router-link
            class="info-more cursor-pointer flex justify-between items-center cursor-pointer"
            :to="{
              path: '/FullScaleAutonomousDriving',
            }"
          >
            <span class="section-subtitle">{{ $t("home.core.more") }}</span>
            <span class="el-icon-arrow-right" />
          </router-link>
        </div>
        <!-- 右侧列表 -->
        <div class="core-detail flex-1 flex column">
          <div
            class="core-detail-header flex-1 flex column items-end justify-between"
          >
            <img
              src="@/static/img/home/core-decoration.svg"
              alt=""
              class="decoration"
            />
            <p class="detail-title section-title">
              {{ $t("home.core.inteligence") }}
            </p>
          </div>
          <div class="core-detail-list flex">
            <div
              class="core-detail-item flex-1 flex column justify-between ovh por"
              v-for="(item, index) in list"
              :key="index"
            >
              <div class="img-wrapper">
                <img :src="item.img" alt="" class="core-detail-img" />
              </div>
              <div class="item-info flex-1 flex column justify-center">
                <p class="title section-title" v-html="item.title"></p>
                <p class="subtitle section-subtitle">{{ item.detail }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carImg from "@/static/img/home/core-auto.webp";
import aiImg from "@/static/img/home/core-ai.webp";
import droneImg from "@/static/img/home/core-drone.webp";

export default {
  data() {
    return {};
  },
  computed: {
    list() {
      const imgs = [carImg, aiImg, droneImg];
      return this.$t("home.core.list").map((item, index) => ({
        ...item,
        img: imgs[index],
      }));
    },
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped lang="scss">
.core {
  * {
    &::-webkit-scrollbar {
      /* WebKit */
      width: 0;
      height: 0;
    }
  }
  .content {
    width: 100%;
    padding: 5rem 0 5.88rem;
    .title-wrapper {
      width: 60rem;
      margin: 0 auto 3rem;
      .section-title {
        margin-bottom: 1rem;
      }
    }
    .content-main {
      width: 71.841rem;
      height: 40rem;
      margin: 0 auto;
      .core-info {
        width: 19.6rem;
        height: 100%;
        .info-panel {
          width: 100%;
          height: 27.625rem;
          padding: 4.95rem 3.17rem 0;
          border-radius: 0.25rem;
          background: linear-gradient(
            141deg,
            rgba(62, 62, 133, 0.3) 19.92%,
            rgba(35, 36, 88, 0.3) 83.01%
          );
          box-shadow: 0 2rem 1.5rem 0 rgba(7, 10, 22, 0.25);
          backdrop-filter: blur(1rem);
          .title {
            font-size: 1.5rem;
            line-height: 1.1;
            margin-bottom: 1rem;
          }
          .detail {
            font-size: 1rem;
            line-height: 2.5rem;
            text-align: justify;
          }
        }
        .info-more {
          width: 16rem;
          padding: 0.68rem 0;
          margin: 0 auto;
          color: rgba(255, 255, 255, 0.65);
          font-size: 0.875rem;
          .section-subtitle {
            font-size: 0.875rem;
          }
        }
      }
      .core-detail {
        .core-detail-header {
          width: 100%;
          height: 6.7rem;
          position: relative;
          .decoration {
            height: 3.45rem;
            vertical-align: middle;
          }
          .detail-title {
            font-size: 1.5rem;
            line-height: 1.1;
            margin-bottom: 1.1rem;
          }
        }
        .core-detail-list {
          height: 32rem;
          border-radius: 0.25rem;
          overflow: hidden;
          box-shadow: 1rem 1.5rem 2.5rem 0 rgba(5, 3, 36, 0.4);
          .core-detail-item {
            height: 100%;
            // border: 1px solid #fff;
            // border-image: linear-gradient(to bottom, #8f41e9, #578aef) 1;
            background: linear-gradient(
              193deg,
              rgba(128, 186, 240, 0.1) 22.73%,
              rgba(16, 28, 60, 0.1) 72.38%
            );
            box-shadow: 1rem 1.5rem 2.5rem 0 rgba(5, 3, 36, 0.4);
            backdrop-filter: blur(1rem);
            &::before,
            &::after {
              content: "";
              position: absolute;
              top: 0;
              right: 0;
              width: 0.0625rem;
              height: 100%;
              background: linear-gradient(
                to bottom,
                rgba(255, 255, 255, 1),
                rgba(255, 255, 255, 0.15)
              );
              z-index: 2;
              opacity: 0.4;
            }
            &::before {
              left: 0;
              right: auto;
            }
            .img-wrapper {
              width: 100%;
              height: 19.6rem;
              overflow: hidden;
              .core-detail-img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .item-info {
              padding: 0 1.5rem;
              gap: 1rem;
              .title {
                font-size: 1.2rem;
                line-height: 1.68;
              }
              .subtitle {
                font-size: 0.875rem;
                line-height: 1.74;
              }
            }
          }
        }
      }
    }
  }
  &.en {
    .content {
      .content-main {
        .core-info {
          .info-panel {
            .detail {
              line-height: 1.5;
              text-align: initial;
            }
          }
        }
        .core-detail {
          .core-detail-list {
            .core-detail-item {
              .item-info {
                padding: 0.85rem 1.5rem;
                justify-content: start;
                overflow: auto;
                .subtitle {
                  line-height: 1.5rem;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
